import { render, staticRenderFns } from "./BrandPrivacy.vue?vue&type=template&id=74c8c310&scoped=true"
import script from "./BrandPrivacy.vue?vue&type=script&lang=js"
export * from "./BrandPrivacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c8c310",
  null
  
)

export default component.exports